import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../../helpers/constants";
import useUserData from "../../../hooks/user/useUserData";
import {useTranslation} from "react-i18next";
import {ALERTS} from "../../../locales/components/namespaces";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import {enqueueSnackbar} from "notistack";
import useUserAction from "../../../hooks/user/useUserAction";

const useGroups = () => {
	const {token, isLoggedIn} = useUserData()
	const {userLogout} = useUserAction()
	const {t} = useTranslation(ALERTS)
	const [loading, setLoading] = useState(false)
	const [groups, setGroups] = useState([])
	const [updateGroups, setUpdateGroups] = useState(false)
	
	useEffect(() => {
		setLoading(true)
		axios({
			method: 'get',
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/groups/list`,
		}).then((response) => {
			setGroups(response.data)
			setLoading(false)
		}).catch(error => {
			setLoading(false)
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to get groups list.')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}, [updateGroups])
	
	const store = (newRow) => {
		axios({
			method: 'post',
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/groups/store`,
			data: newRow
		}).then(response => {
			enqueueSnackbar(t('New group added successfully!'), {
					variant: 'success'
				}
			)
			setUpdateGroups(!updateGroups)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to store new group!')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	const update = (newRow, oldRow) => {
		axios({
			method: 'post',
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/groups/update`,
			data: newRow
		}).then(response => {
			enqueueSnackbar(t('Group updated successfully!'), {
					variant: 'success'
				}
			)
			setUpdateGroups(!updateGroups)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to update group!')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	const remove = (id) => {
		axios({
			method: 'post',
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/groups/remove`,
			data: {
				id: id
			}
		}).then(response => {
			enqueueSnackbar(t('Group deleted successfully!'), {
					variant: 'success'
				}
			)
			setUpdateGroups(!updateGroups)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to delete group!')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	return {
		loading,
		groups,
		store,
		update,
		remove
	}
}

export default useGroups